import { ChildScores } from '@yandex-int/k-common/typings';

import * as constants from './constants';
import { Certificates } from './typings';

export const getLessonScoresRequest = (childIds: number[], clessonId: number) =>
    <const>{
        type: constants.GET_LESSON_SCORES_REQUEST,
        childIds,
        clessonId,
    };

export const getLessonCertificatesRequest = (clessonId: number) =>
    <const>{
        type: constants.GET_LESSON_CERTIFICATES_REQUEST,
        clessonId,
    };

export const getLessonCertificatesSuccess = (clessonId: number, certificates: Certificates) =>
    <const>{
        type: constants.GET_LESSON_CERTIFICATES_SUCCESS,
        clessonId,
        certificates,
    };

export const getLessonCertificatesError = (clessonId: number) =>
    <const>{
        type: constants.GET_LESSON_CERTIFICATES_ERROR,
        clessonId,
    };

export const setLessonScores = (clessonId: number, scores: ChildScores) =>
    <const>{
        type: constants.SET_LESSON_SCORES,
        clessonId,
        scores,
    };
